import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';
import { EcommerceGenericoService, OrderEstado, PedidosMmaxEccomerce, TurnosRetiroEccomerce, Usuario } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { MarianomGeneral } from '../../marianom-general.service';

@Component({
  selector: 'confirmar-checkout-modal',
  templateUrl: './confirmar-checkout-modal.component.html',
  styleUrls: ['./confirmar-checkout-modal.component.scss']
})

export class ConfirmarCheckoutModalComponent implements OnInit {
  constructor(private serv: MarianomGeneral, private genServ: EcommerceGenericoService, private router: ActivatedRoute, private route: Router, private modal: ModalService) {
    this.genServ.getPagoDiferido().subscribe(data => {
      this.pagoDiferido = data;
    })
    this.textoCerrarPedido = this.genServ.getTextoCerrarPedido() || this.textoCerrarPedido;
    this.checkForm = false;
  }

  ngOnInit(): void {
  }

  cerrarPedido() {

    this.turnoselecionado = this.serv.ultimoTurno();
    this.serv.setTurno(this.turnoselecionado);
    if (this.observacion) {
      this.genServ.setObservacion(this.observacion)
    }

    this.genServ.agregarItemEnvio();

    this.modal.close('confirmar-checkout-modal-1');

    this.serv.prayandpaid().subscribe(data => {
      let pedido = data['pedido'] as PedidosMmaxEccomerce;
      this.genServ.guardarpedido(pedido);
      this.genServ.setDatosEnvio(undefined)
      //console.log("PAGODIFERIDO", this.pagoDiferido);
      if (pedido.estado === OrderEstado.CERRADO || pedido.estado === 'Cerrado') {
        this.serv.abrirMensaje('✅ ¡Pedido recibido!', 'Tu pedido está pendiente de confirmación de pago.');
      } else {
        this.serv.abrirMensaje('Pedido recibido!', '¡Tu pedido ha sido recibido con éxito!');
      }

      if (this.pagoDiferido === "E") {
        this.serv.navigator.endline(this.router);
        this.genServ.resetEccomerce();
      }
      else {
        this.route.navigate(['/checkout/finalizar']);
      }
    });
  }

  cancelar() {
    this.modal.close('confirmar-checkout-modal-1')
  }
  get ocultarPrecios() {
    return this.genServ.isOcultarPrecio()
  }

  observacion: string;
  turnoselecionado: TurnosRetiroEccomerce;
  envioHabilitado: string;
  textoCerrarPedido = "Esta acción finalizará el pedido."
  "<br >Una vez que confirme, no podrá agregar más productos ni modificar los turnos para este pedido. "
  "<br >¿Desea continuar con el cierre del pedido?";
  pagoDiferido: string;
  checkForm: boolean;
}
